import { render, staticRenderFns } from "./Singlecard.vue?vue&type=template&id=d44c729c&scoped=true"
import script from "./Singlecard.vue?vue&type=script&lang=js"
export * from "./Singlecard.vue?vue&type=script&lang=js"
import style0 from "./Singlecard.vue?vue&type=style&index=0&id=d44c729c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44c729c",
  null
  
)

export default component.exports